<template>
    <plan-learn-more-dialog :visible.sync="visible"  @closed="handleCloseDialog" :planType="planType" />
 </template>
 
 <script>
 import { ConfirmComponent } from '../common/service-dialog/confirm';
 import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';
 import { PLAN_LEARN_MORE_DIALOG as PlanLearnMoreDialog } from '@zoom/billing-shared';
 
 export default {
 name: 'CustomAvatarLearnMoreDialog',
 mixins: [ConfirmComponent],
 components: {
    PlanLearnMoreDialog
   },
 data () {
   return {
     visible: false,
     planType: 'custom_avatar'
   };
 },
 watch: {
   visible(val) {
     if (this.$context.is.modal) {
       val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
     }
   }
 },
 mounted () {
 },
 beforeDestroy () {
 },
 methods: {
   handleCloseDialog () {
     this.visible = false;
   },
 },
 };
 </script>